import TextEffectsSharedPreviewdMapper from '../../TextEffectsShared/viewer/TextEffectsShared.previewMapper';

export default TextEffectsSharedPreviewdMapper;
